import React from 'react';
import { Col, Row } from 'reactstrap';
import renderSelectField from '../../../shared/components/form/Select';
import PlusCircleIcon from 'mdi-react/PlusCircleIcon';
import MinusCircleIcon from 'mdi-react/MinusCircleIcon';
import types from '../../types.json';
import themes from '../../themes.json';

const WordDetailEditRow = ({
  count,
  detail,

  onChangeDetail,
  onClickAdd,
  onClickRemove,

  showAddBtn,
  showRemoveBtn
}) => {
  return (
    <>
      <Row style={{
        width: '100%',
        margin: '5px 0'
      }}>
        <p className="word-detail-vertical-middle word-detail-row-number">{count}</p>
        <Col md={6} lg={2} style={{ padding: 0 }}>
          {renderSelectField({
              input: {
                name: 'type',
                value: Object.keys(detail['type']).length === 0 ? '' : detail['type'],
                onChange: (option) => onChangeDetail({
                  ...detail,
                  type: option
                })
              },
              meta: {
                touched: false,
                error: ''
              },
              placeholder: '유형',
              options: types.filter(type => {
                return type.lang.includes('en');
              })
            }
          )}
        </Col>
        <Col md={6} lg={4}>
          {renderSelectField({
              input: {
                name: 'theme',
                value: Object.keys(detail['theme']).length === 0 ? '' : detail['theme'],
                onChange: (option) => onChangeDetail({
                  ...detail,
                  theme: option
                })
              },
              meta: {
                touched: false,
                error: ''
              },
              placeholder: '주제',
              options: themes.filter(type => {
                return type.lang.includes('en');
              })
            }
          )}
        </Col>
        <Col md={10} lg={5} style={{
          paddingLeft: 0,
          paddingRight: '5px'
        }}>
          <input name="mean" type="text" placeholder="뜻"
                 autoComplete="off"
                 value={detail['mean'] || ''}
                 onChange={(e) => onChangeDetail({
                   ...detail,
                   mean: e.target.value.trimStart()
                 })}
          />
        </Col>
        <Col md={2} lg={1} style={{
          padding: 0,
          margin: 'auto 0',
          textAlign: 'right'
        }}>
          <MinusCircleIcon onClick={onClickRemove} style={{ visibility: showRemoveBtn ? 'visible' : 'hidden' }}/>
          <PlusCircleIcon onClick={onClickAdd} style={{ visibility: showAddBtn ? 'visible' : 'hidden' }}/>
        </Col>
      </Row>
    </>
  );
};

export default WordDetailEditRow;
